<template>
  <transition name="view-upload">
    <div ref="view" class="view-upload" @click="closeView">
      <img :src="src" alt="image" />
    </div>
  </transition>
</template>
<script>
export default {
  name: 'ViewUpload',
  props: {
    active: {
      default: false,
      type: Boolean
    },
    src: {
      default: null,
      type: String
    }
  },
  mounted() {
    this.insertBody(this.$refs.view)
  },
  upload() {
    this.insertBody(this.$refs.view)
  },
  methods: {
    closeView(evt) {
      if (evt.target.tagName !== 'IMG') {
        this.$parent.viewActive = false
      }
    },

    insertBody(elx, parent) {
      let bodyX = parent ? parent : document.body
      bodyX.insertBefore(elx, bodyX.firstChild)
    },
    removeBody(element, parent) {
      let bodyX = parent ? parent : document.body
      bodyX.removeChild(element)
    },
    changePosition(elx, content, conditional) {
      let topX = 0
      let leftX = 0
      let widthX = 0
      let scrollTopX = window.pageYOffset || document.documentElement.scrollTop
      if (elx.getBoundingClientRect().top + 300 >= window.innerHeight) {
        setTimeout(() => {
          if (conditional) {
            topX = elx.getBoundingClientRect().top - content.clientHeight + scrollTopX
          } else {
            topX = elx.getBoundingClientRect().top - content.clientHeight + elx.clientHeight + scrollTopX
          }
        }, 1)
      } else {
        topX = conditional
          ? elx.getBoundingClientRect().top + elx.clientHeight + scrollTopX + 5
          : elx.getBoundingClientRect().top + scrollTopX
      }

      leftX = elx.getBoundingClientRect().left
      widthX = elx.offsetWidth

      return {
        left: `${leftX}px`,
        top: `${topX}px`,
        width: `${widthX}px`
      }
    }
  }
}
</script>
